/**
 * Layout Breakpoints
 */
export enum BreakPoints {
  medium = '40em',
  xmedium = '52em',
  large = '64em',
  xlarge = '75em',
  xxlarge = '90em',
}
